<div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
        <i class="icofont icofont-clock-time me-2"></i>
        Seguimiento de queja
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="cerrar()"></button>
</div>

<div class="modal-body">

    <!-- Resumen de la queja -->
    <div class="card border-0 shadow-sm mb-3">
        <div class="card-body py-2">
            <div class="row g-2 align-items-center">
                <div class="col-md-4">
                    <small class="text-dark d-block">Colaborador</small>
                    <strong>{{ queja?.ColaboradorQuejaData?.nombreCompleto || '-' }}</strong>
                </div>
                <div class="col-md-2">
                    <small class="text-dark d-block">Tipo</small>
                    <strong>{{ queja?.TipoQuejaData?.descripcion || '-' }}</strong>
                </div>
                <div class="col-md-2">
                    <small class="text-dark d-block">Fecha queja</small>
                    <strong>{{ queja?.fecha_queja | date:'dd/MM/yyyy' }}</strong>
                </div>
                <div class="col-md-2">
                    <small class="text-dark d-block">Estado gestión</small>
                    <span class="badge rounded-pill bg-info">{{ queja?.EstadoGestionData?.descripcion || '-' }}</span>
                </div>
                <div class="col-md-2 text-md-end">
                    <small class="text-dark d-block">Avance actual</small>
                    <strong>{{ ultimoAvance }}%</strong>
                </div>
            </div>
            <div class="progress mt-2" style="height: 6px;">
                <div class="progress-bar"
                     [ngClass]="ultimoAvance >= 100 ? 'bg-success' : (ultimoAvance >= 50 ? 'bg-info' : 'bg-warning')"
                     [style.width.%]="ultimoAvance">
                </div>
            </div>
            <div class="mt-2 text-truncate" ngbTooltip="{{ queja?.motivo }}">
                <small class="text-dark">Motivo:</small> {{ queja?.motivo || '-' }}
            </div>
        </div>
    </div>

    <!-- Formulario nuevo / edición de seguimiento -->
    <div class="form-section mb-3">
        <div class="form-section__title text-dark">
            <i class="icofont icofont-plus-circle me-1"></i>
            {{ modoEdicion ? 'Editar seguimiento' : 'Nuevo seguimiento' }}
        </div>

        <form [formGroup]="seguimientoForm" (ngSubmit)="guardar()" class="pt-2" novalidate>
            <div class="row g-3">

                <div class="col-md-4">
                    <label class="form-label text-dark">
                        Fecha del seguimiento: <span class="text-danger">*</span>
                    </label>
                    <input type="date" class="form-control" formControlName="fecha_seguimiento"
                        [class.is-invalid]="seguimientoForm.get('fecha_seguimiento')?.invalid && seguimientoForm.get('fecha_seguimiento')?.touched">
                    <div class="invalid-feedback">La fecha es obligatoria.</div>
                </div>

                <div class="col-md-8">
                    <label class="form-label text-dark">
                        Avance (%): <span class="text-danger">*</span>
                    </label>
                    <!-- Antes era un input de rango; ahora es numérico para permitir ingreso exacto y validación -->
                    <input type="number" class="form-control" min="0" max="100" step="1"
                        formControlName="avance"
                        [class.is-invalid]="seguimientoForm.get('avance')?.invalid && seguimientoForm.get('avance')?.touched">
                    <div class="invalid-feedback">
                        <span *ngIf="seguimientoForm.get('avance')?.errors?.avanceMenor">
                            El avance debe ser mayor al último registrado ({{ ultimoAvance }}%).
                        </span>
                        <span *ngIf="!seguimientoForm.get('avance')?.errors?.avanceMenor">
                            Ingresa un avance válido entre 0 y 100.
                        </span>
                    </div>
                </div>

                <div class="col-12">
                    <label class="form-label text-dark">
                        Observación: <span class="text-danger">*</span>
                    </label>
                    <textarea class="form-control" rows="2" formControlName="observacion"
                        placeholder="Describa el avance o la gestión realizada"
                        [class.is-invalid]="seguimientoForm.get('observacion')?.invalid && seguimientoForm.get('observacion')?.touched"></textarea>
                    <div class="invalid-feedback">La observación es obligatoria.</div>
                </div>

            </div>

            <div class="d-flex justify-content-end gap-2 mt-3">
                <button type="button" class="btn btn-secondary" *ngIf="modoEdicion"
                    (click)="cancelarEdicion()" [disabled]="guardando">
                    Cancelar
                </button>
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                    <span *ngIf="!guardando">
                        <i class="icofont icofont-save me-1"></i>
                        {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                    </span>
                    <span *ngIf="guardando">
                        <span class="spinner-border spinner-border-sm me-1"></span>
                        Guardando...
                    </span>
                </button>
            </div>
        </form>
    </div>

    <!-- Historial de seguimientos -->
    <div class="form-section">
        <div class="form-section__title text-dark">
            <i class="icofont icofont-listine-dots me-1 text-dark"></i>
            Historial de seguimientos
        </div>

        <div *ngIf="cargandoListado" class="text-center py-3">
            <div class="spinner-border text-primary" role="status"></div>
        </div>

        <div *ngIf="!cargandoListado" class="table-responsive mt-2">
            <ng-container *ngIf="seguimientos?.length > 0; else sinDatos">
                <table class="table table-bordered table-hover align-middle">
                    <thead class="bg-primary text-white">
                        <tr>
                            <th class="text-center">FECHA</th>
                            <th class="text-center">OBSERVACIÓN</th>
                            <th class="text-center">AVANCE</th>
                            <th class="text-center">ESTADO</th>
                            <th class="text-center">ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let seg of seguimientos">
                            <td class="text-center">{{ seg.fecha_seguimiento | date:'dd/MM/yyyy' }}</td>
                            <td class="text-truncate" style="max-width: 260px;" ngbTooltip="{{ seg.observacion }}">
                                {{ seg.observacion }}
                            </td>
                            <td class="text-center" style="min-width: 120px;">
                                <div class="progress" style="height: 6px;">
                                    <div class="progress-bar"
                                         [ngClass]="seg.avance >= 100 ? 'bg-success' : (seg.avance >= 50 ? 'bg-info' : 'bg-warning')"
                                         [style.width.%]="seg.avance">
                                    </div>
                                </div>
                                <small>{{ seg.avance }}%</small>
                            </td>
                            <td class="text-center">
                                <span class="badge rounded-pill"
                                    [ngClass]="Number(seg.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                                    {{ Number(seg.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                </span>
                            </td>
                            <td class="text-center">
                                <div class="d-flex justify-content-center gap-1">
                                    <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                        ngbTooltip="Documentos"
                                        (click)="abrirModalDocumentosSeguimiento(modalDocumentosSeguimiento, seg)">
                                        <i class="icofont icofont-file-document" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                        *ngIf="Number(seg.estado) === 1" ngbTooltip="Editar"
                                        (click)="editarSeguimiento(seg)">
                                        <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                        *ngIf="Number(seg.estado) === 1" ngbTooltip="Inactivar"
                                        (click)="cambiarEstado(seg, 0)">
                                        <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                        *ngIf="Number(seg.estado) !== 1" ngbTooltip="Activar"
                                        (click)="cambiarEstado(seg, 1)">
                                        <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <ng-template #sinDatos>
                <div class="text-center py-3 text-primary">Aún no hay seguimientos registrados.</div>
            </ng-template>
        </div>
    </div>

</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrar()">Cerrar</button>
</div>

<!-- ===================== MODAL: DOCUMENTOS DEL SEGUIMIENTO ===================== -->
<ng-template #modalDocumentosSeguimiento let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <button *ngIf="mostrandoPreviewDocumento" type="button" class="btn btn-sm btn-light me-2"
                (click)="cerrarPreviewDocumento()" ngbTooltip="Volver">
                <i class="icofont icofont-arrow-left"></i>
            </button>
            {{ mostrandoPreviewDocumento ? (documentoSeleccionado?.name || 'Documento') : 'Documentos del seguimiento' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">

        <ng-container *ngIf="!mostrandoPreviewDocumento">

            <div class="alert alert-secondary d-flex align-items-center mb-4"
                *ngIf="Number(seguimientoSeleccionadoDocs?.estado) === 0">
                <i class="icofont icofont-lock fs-5 me-2"></i>
                Este seguimiento está <strong class="mx-1">inactivo</strong>, por lo tanto no se pueden cargar ni modificar
                documentos.
            </div>

            <div class="mb-4" *ngIf="Number(seguimientoSeleccionadoDocs?.estado) !== 0">
                <input type="file" class="d-none" id="inputDocumentosSeguimientoQueja" multiple (change)="onFileChangeDocumento($event)">
                <label for="inputDocumentosSeguimientoQueja"
                    class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">
                    <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                    <p class="mb-2 fw-semibold text-primary text-center">Haz click o arrastra archivos para cargar</p>
                    <span class="btn btn-primary btn-sm rounded-pill px-3">Seleccionar archivos</span>
                </label>
            </div>

            <div *ngIf="nuevosArchivosDocs.length > 0 && Number(seguimientoSeleccionadoDocs?.estado) !== 0" class="mb-4">
                <h6 class="fw-bold">Archivos seleccionados</h6>
                <div class="row g-2">
                    <div class="col-6 col-md-3" *ngFor="let item of nuevosArchivosDocs; let i = index">
                        <div class="card p-2 text-center h-100">
                            <img *ngIf="item.preview" [src]="item.preview" class="mb-1 rounded" style="max-height: 90px; object-fit: cover;">
                            <i *ngIf="!item.preview" class="fa fa-file-pdf-o fs-2 text-danger mb-1"></i>
                            <small class="text-truncate d-block" [title]="item.file.name">{{ item.file.name }}</small>
                            <button class="btn btn-sm btn-outline-danger mt-1" (click)="quitarArchivoNuevo(i)">
                                <i class="bi bi-trash"></i> Quitar
                            </button>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success mt-3" [disabled]="subiendoDocumentos" (click)="subirDocumentosSeguimiento()">
                    <span *ngIf="subiendoDocumentos" class="spinner-border spinner-border-sm me-1"></span>
                    <i class="icofont icofont-cloud-upload me-1"></i> Subir {{ nuevosArchivosDocs.length }} archivo(s)
                </button>
            </div>

            <hr>

            <h6 class="fw-bold">Documentos cargados</h6>
            <div *ngIf="cargandoDocumentos" class="text-center py-3">
                <div class="spinner-border text-primary"></div>
            </div>

            <div *ngIf="!cargandoDocumentos && documentosPlan.length === 0" class="text-primary text-center py-3">
                No hay documentos cargados para este seguimiento.
            </div>

            <div class="row g-2" *ngIf="!cargandoDocumentos && documentosPlan.length > 0">
                <div class="col-12 col-md-4" *ngFor="let doc of documentosPlan">
                    <div class="card p-2 text-center h-100">
                        <img *ngIf="doc.isImage" [src]="doc.url" class="mb-1 rounded cursor-pointer"
                            style="max-height: 90px; object-fit: cover;" (click)="verDocumento(doc)">
                        <i *ngIf="!doc.isImage" class="fa fa-file-pdf-o fs-2 text-danger mb-1 cursor-pointer"
                            (click)="verDocumento(doc)"></i>
                        <small class="text-truncate d-block" [title]="doc.name">{{ doc.name }}</small>
                        <div class="d-flex gap-1 justify-content-center mt-1">
                            <button class="btn btn-sm btn-outline-primary" (click)="verDocumento(doc)">
                                <i class="icofont icofont-eye"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-warning" *ngIf="Number(seguimientoSeleccionadoDocs?.estado) !== 0"
                                (click)="reemplazarDocumentoSeguimiento(doc)">
                                <i class="icofont icofont-refresh"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-danger" *ngIf="Number(seguimientoSeleccionadoDocs?.estado) !== 0"
                                (click)="eliminarDocumentoSeguimiento(doc)">
                                <i class="icon-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-container *ngIf="mostrandoPreviewDocumento">
            <div class="text-center" style="min-height: 50vh;">

                <img *ngIf="documentoSeleccionado?.isImage" [src]="documentoSeleccionado?.url" class="img-fluid rounded"
                    style="max-height: 65vh;">

                <iframe *ngIf="documentoSeleccionado?.isPdf" [src]="documentoSeleccionado?.urlSegura"
                    style="width: 100%; height: 65vh; border: none;">
                </iframe>

                <div *ngIf="!documentoSeleccionado?.isImage && !documentoSeleccionado?.isPdf"
                    class="d-flex flex-column align-items-center justify-content-center py-5">
                    <i class="fa fa-file-o fs-1 text-secondary mb-3"></i>
                    <p class="text-muted">Este tipo de archivo no se puede previsualizar en el navegador.</p>
                </div>

                <a *ngIf="documentoSeleccionado?.url" [href]="documentoSeleccionado?.url" target="_blank"
                    class="btn btn-outline-primary mt-3">
                    <i class="icofont icofont-download"></i> Abrir en pestaña nueva
                </a>
            </div>
        </ng-container>

    </div>

    <div class="modal-footer">
        <button *ngIf="mostrandoPreviewDocumento" type="button" class="btn btn-outline-secondary"
            (click)="cerrarPreviewDocumento()">
            <i class="icofont icofont-arrow-left me-1"></i>Volver al listado
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
</ng-template>